import { render, staticRenderFns } from "./login.vue?vue&type=template&id=160dc4e6&"
import script from "@/model/login.js?vue&type=script&lang=js&"
export * from "@/model/login.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports